// Turns a displayed image into a real File for the download action.
// cache: 'no-store' is required: the <img> tag already cached this same URL
// from a request WITHOUT an Origin header, and S3 omits CORS headers on
// those. A cors-mode fetch served from that cached entry is then blocked
// ("No 'Access-Control-Allow-Origin' header"). Going straight to S3 gets a
// fresh response that carries the CORS headers. Costs a re-download of the
// selected images, which is fine for an explicit download action.
export const fetchImageFile = async (src: string, fileName: string): Promise<File> => {
  const response = await fetch(src, { cache: 'no-store' })
  if (!response.ok) {
    throw new Error(`HTTP ${response.status} fetching ${fileName}`)
  }
  const blob = await response.blob()
  const type = blob.type !== '' ? blob.type : 'image/jpeg'
  return new File([blob], fileName, { type })
}
